__turbopack_context__.v({
  "arrow": "StockPricesTable-module__3StytW__arrow",
  "customTable": "StockPricesTable-module__3StytW__customTable",
  "dailyChange": "StockPricesTable-module__3StytW__dailyChange",
  "date": "StockPricesTable-module__3StytW__date",
  "name": "StockPricesTable-module__3StytW__name",
  "negative": "StockPricesTable-module__3StytW__negative",
  "positive": "StockPricesTable-module__3StytW__positive",
  "price": "StockPricesTable-module__3StytW__price",
  "priceArrow": "StockPricesTable-module__3StytW__priceArrow",
  "tableGrp": "StockPricesTable-module__3StytW__tableGrp",
});
